<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.title" placeholder="请输入标题" clearable></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <DatePicker v-model="dateData" type="daterange" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择日期范围" style="width: 100%;"></DatePicker>
        </Col>
        <Col span="12" :lg="12" :md="24" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">重置</Button>
        </div>
        <div>
          <Button v-permission="'setting.infoRelease.insert'" v-if="isCompany" style="margin-left:6px;" type="primary" icon="md-add" @click="create()">新增</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <detail ref="detail"></detail>
    <edit ref="edit" @on-update="handleUpdate"></edit>
    <approval ref="approval" @on-update="handleUpdate"></approval>
  </sl-page>
</template>
<script>
import detail from './detail'
import edit from './edit'
import approval from './approval'

import global from '@/util/mixin/global'

import { Modal, Notice } from 'iview'
import dics from './dics.js'

export default {
  mixins: [global],
  components: { detail, edit, approval },
  data() {
    return {
      ...dics,
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '信息标题',
          key: 'title',
          minWidth: 150,
        },
        {
          title: '发布者',
          key: 'pubObjName',
          minWidth: 150,
        },
        {
          title: '发布时间',
          minWidth: 180,
          render: (h, params) => {
            let row = params.row
            let txt = ''
            if (row.releaseTime) {
              txt = this.$utils.datetime(row.releaseTime)
            }
            return h('span', txt)
          }
        },
        {
          title: '创建人',
          key: 'creatorName',
          minWidth: 150,
        },
        {
          title: '状态',
          minWidth: 100,
          render: (h, params) => {
            let txt = this.$utils.value2label(dics.statusData, params.row.status)
            return h('span', txt)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 220,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let row = params.row
            let acts = []

            let detailH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.query',
                }
              ],
              on: {
                click: () => {
                  this.detail(params.row)
                }
              }
            }, '查看')
            let editH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.update',
                }
              ],
              on: {
                click: () => {
                  this.edit(params.row)
                }
              }
            }, '编辑')
            let deleteH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.delete',
                }
              ],
              on: {
                click: () => {
                  this.delete(params.row)
                }
              }
            }, '删除')

            let approvalH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.approval',
                }
              ],
              on: {
                click: () => {
                  this.approval(params.row)
                }
              }
            }, '审批')
            let commitH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.submit',
                }
              ],
              on: {
                click: () => {
                  this.commit(params.row)
                }
              }
            }, '提交审核')
            let uncommitH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.cancel',
                }
              ],
              on: {
                click: () => {
                  this.uncommit(params.row)
                }
              }
            }, '撤回审核')
            let closeH = h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              directives: [
                {
                  name: 'permission',
                  value: 'setting.infoRelease.close',
                }
              ],
              on: {
                click: () => {
                  this.close(params.row)
                }
              }
            }, '关闭')

            if (this.isCompany && row.status !== 3) {
              acts.push(detailH)
              if (row.status === 0) {
                acts.push(commitH, editH, deleteH)
              }
              if (row.status === 1) {
                acts.push(uncommitH, deleteH)
              }
              if (row.status === 2) {
                acts.push(closeH)
              }
              if (row.status === 4) {
                acts.push(commitH, editH, deleteH)
              }
            } else if (this.isAdmin && row.status !== 3) {
              acts.push(detailH)
              if (row.status === 1) {
                acts.push(approvalH)
              }
            } else {
              acts.push(detailH)
            }
            return h('div', acts)
          }
        }
      ],
      data: [],
      params: {
        title: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      companies: [],
      selection: [],
      dateData: [],
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
    importUrl() {
      return this.$request.deviceImportUrl()
    }
  },
  created() {
    this.def = { ...this.params }

    this.list()
  },

  methods: {

    list() {
      let search = this.$utils.filterSearch(this.params)

      if (this.dateData.length && this.dateData[0] && this.dateData[1]) {
        search.startTime = this.$utils.date(this.dateData[0])
        search.endTime = this.$utils.date(this.dateData[1])
      }

      let params = { search: search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.informationQuerypage(params).then(resp => {
        this.loading = false
        if (resp.code == 0) {
          this.data = resp.data.list || []
          this.page.total = resp.data.total || 0
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
    create() {
      this.$refs.edit.init(0)
    },
    edit(row) {
      this.$refs.edit.init(row.id)
    },
    detail(row) {
      this.$refs.detail.init(row.id)
    },
    delete(row) {
      let promise = this.$request.informationDelete
      let txt = '确定删除？'
      this.confirmModal(promise, txt, row)
    },
    approval(row) {
      this.$refs.approval.init(row.id)
    },
    commit(row) {
      let promise = this.$request.informationCommit
      let txt = '提交审核？'
      this.confirmModal(promise, txt, row)
    },
    uncommit(row) {
      let promise = this.$request.informationUncommit
      let txt = '撤回审核？'
      this.confirmModal(promise, txt, row)
    },
    close(row) {
      let promise = this.$request.informationClose
      let txt = '确定关闭？'
      this.confirmModal(promise, txt, row)
    },
    confirmModal(promise, txt, row) {
      this.$ui.confirm(promise, txt)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.dateData = []
      this.list()
    },

    handleUpdate() {
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    handleImportComplete(resp) {
      if (resp.code) {
        this.$Modal.warning({ title: '设备导入', content: resp.msg.replace(/[\r\n;]/g, '<br />') })
      } else {
        this.$Notice.success({ title: '导入成功', duration: 20, desc: '您可在 基础设置->导入管理 中查看处理结果！' })

      }
      this.list()
    }
  }
}

</script>
